import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IAuditTrailDataSummaryParamsBody,
  IAuditTrailDataSummaryPostResponse,
} from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setAuditTrailTableSummaryData } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useAuditTrailTableDataSummaryAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError, toastNotification } = useAPIUtils();

  const execute = useCallback(
    async (filterBody: IAuditTrailDataSummaryParamsBody) => {
      dispatch(
        setLoading({
          key: "isInventoryProductGoodInventory",
          status: true,
        }),
      );
      try {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: true,
          }),
        );
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(`${INVENTORY_MODULE?.AUDIT_TRAIL_TABLE_DATA_SUMMARY?.baseURL}`, filterBody, {
            headers: {
              "x-audit-api-key": `Z74XW)a0dVszqE3d#=gUmR5=2f7gh5Kh#eQQXtuY&D%nRfeHyJXm_wtGyWdzzQx#(Z5b2`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAuditTrailDataSummaryPostResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              dispatch(setAuditTrailTableSummaryData({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: true, message: "batch" };
            } else {
              dispatch(setAuditTrailTableSummaryData({ data: null }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: false, message: "product_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isvaccinationTableLoading",
                status: false,
              }),
            );
            captureError(e);
            return { status: false, message: "product_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
